<template>
  <ContentBanner
    variant="warning"
    icon="changed"
    title="Job Profile Changed"
    primary-label="Create Acknowledgement"
    secondary-label="Compare Job Profiles"
    secondary-color="brandPrimary"
  >
    <p class="text-body-3 text-textLight mb-0">
      {{ description }}
    </p>
    <template #actions>
      <DpplDarkTooltip
        v-if="!isActionEnabled"
        tooltip-placement="bottom"
        light-mode
      >
        <template #activator="{ onMouseenter, onMouseleave }">
          <span
            class="banner-action-disabled-wrapper"
            @mouseenter="onMouseenter"
            @mouseleave="onMouseleave"
          >
            <v-btn
              color="brandPrimary"
              variant="flat"
              size="small"
              disabled
            >
              Create Acknowledgement
            </v-btn>
          </span>
        </template>
        <template #tooltip-content>
          <p class="text-body-2 text-textDark">
            {{ disabledTooltip }}
          </p>
        </template>
      </DpplDarkTooltip>
      <v-btn
        v-else
        color="brandPrimary"
        variant="flat"
        size="small"
        @click="emit('create')"
      >
        Create Acknowledgement
      </v-btn>
      <DpplDarkTooltip
        v-if="!isCompareEnabled"
        tooltip-placement="bottom"
        light-mode
      >
        <template #activator="{ onMouseenter, onMouseleave }">
          <span
            class="banner-action-disabled-wrapper"
            @mouseenter="onMouseenter"
            @mouseleave="onMouseleave"
          >
            <v-btn
              variant="outlined"
              size="small"
              color="brandPrimary"
              class="content-banner-secondary-btn content-banner-secondary-btn-brand"
              disabled
            >
              Compare Job Profiles
            </v-btn>
          </span>
        </template>
        <template #tooltip-content>
          <p class="text-body-2 text-textDark">
            {{ compareDisabledTooltip }}
          </p>
        </template>
      </DpplDarkTooltip>
      <v-btn
        v-else
        variant="outlined"
        size="small"
        color="brandPrimary"
        class="content-banner-secondary-btn content-banner-secondary-btn-brand"
        @click="emit('compare-job-profiles')"
      >
        Compare Job Profiles
      </v-btn>
    </template>
  </ContentBanner>
</template>

<script setup>
import ContentBanner from '@/components/library/ContentBanner.vue';
import DpplDarkTooltip from '@/components/datapeople/DpplDarkTooltip.vue';

defineProps({
  description: { type: String, required: true },
  isActionEnabled: { type: Boolean, default: true },
  isCompareEnabled: { type: Boolean, default: true },
  disabledTooltip: { type: String, default: '' },
  compareDisabledTooltip: { type: String, default: '' },
});

const emit = defineEmits(['create', 'compare-job-profiles']);
</script>

<style scoped lang="less">
.banner-action-disabled-wrapper {
  display: inline-block;
}
</style>
